import { Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useMutation } from "@apollo/client";

import { setUpdateBranch, toggleBranchModal } from "../redux/branchSlice";
import { CheckCircleIcon, CrossIcon } from "../../../constants/icon_path";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../components/common/CustomErrorMessage";
import { DISABLE_BRANCH } from "../../../graphql/mutations/branch";
import { GET_BRANCH_LIST } from "../../../graphql/queries/branch";

const BranchTable = ({ data }) => {
  const dispatch = useDispatch();

  const handleEdit = (data) => {
    dispatch(toggleBranchModal());
    dispatch(
      setUpdateBranch({
        id: data.id,
        name: data.name,
        branchLink: data.branchLink,
      })
    );
  };

  const [disableBranch] = useMutation(DISABLE_BRANCH, {
    refetchQueries: [{ query: GET_BRANCH_LIST }],
    onCompleted: ({ disableBranch }) => {
      if (disableBranch) {
        showSuccessToast();
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const renderBoolIcon = (bool) => {
    if (bool) {
      return <CheckCircleIcon size={25} color="green" />;
    } else {
      return <CrossIcon size={25} color="red" />;
    }
  };

  const handleDelete = (data) => {
    const answer = window.confirm("ຕ້ອງການປິດໃຊ້ງານບໍ?");
    if (answer) {
      disableBranch({ variables: { id: data.id, sst: !data.sst } });
    }
  };

  return (
    <>
      <Table bordered responsive>
        <thead>
          <tr>
            <th className="text-center">
              <strong>#</strong>
            </th>
            <th className="text-center">
              <strong>ຊື່ຈຸ</strong>
            </th>
            <th className="text-center">
              <strong>ລິງຂອງຈຸ</strong>
            </th>
            <th className="text-center">
              <strong>ສະຖານະ</strong>
            </th>
            <th className="text-center">
              <strong>ແກ້ໄຂຂໍ້ມູນ</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.map((d, i) => {
            return (
              <tr key={d.id}>
                <td className="text-center">
                  <strong>{i + 1}</strong>
                </td>
                <td className="text-center">{d.name}</td>
                <td className="text-center"> {d.branchLink}</td>
                <td className="text-center">{renderBoolIcon(d.sst)}</td>
                <td className="text-center" style={{ width: "300px" }}>
                  <div
                    className="btn btn-primary shadow me-1"
                    onClick={() => handleEdit(d)}
                  >
                    <i className="fas fa-pencil-alt"></i>
                  </div>
                  <div
                    className={`btn pt-2 btn-${
                      d.sst ? "danger" : "primary"
                    } shadow sharp me-1`}
                    onClick={() => handleDelete(d)}
                  >
                    {d.sst ? "ປິດໃຊ້ງານຈຸສາຂາ" : "ເປິດໃຊ້ງານຈຸສາຂາ"}{" "}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default BranchTable;
